var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadiologyLocationOnMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.875 17.9375C35.875 28.9725 24.4719 36.8385 21.3063 38.8099C21.0649 38.9621 20.7854 39.0429 20.5 39.0429C20.2146 39.0429 19.9351 38.9621 19.6937 38.8099C16.529 36.8385 5.125 28.9725 5.125 17.9375C5.125 9.44623 12.0087 2.5625 20.5 2.5625C28.9913 2.5625 35.875 9.44623 35.875 17.9375Z",
    fill: "#3B86FF",
    stroke: "#AACBFF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.16 18.0399C31.16 20.8671 30.0369 23.5785 28.0377 25.5776C26.0386 27.5768 23.3272 28.6999 20.5 28.6999C17.6728 28.6999 14.9613 27.5768 12.9622 25.5776C10.9631 23.5785 9.83997 20.8671 9.83997 18.0399C9.83997 15.2127 10.9631 12.5013 12.9622 10.5021C14.9613 8.50299 17.6728 7.37988 20.5 7.37988C23.3272 7.37988 26.0386 8.50299 28.0377 10.5021C30.0369 12.5013 31.16 15.2127 31.16 18.0399Z",
    fill: "white",
    stroke: "#AACBFF",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3691 16.8335C22.0387 16.8472 22.6469 17.1273 23.0842 17.5647C23.5352 18.0225 23.8154 18.6443 23.8154 19.3345C23.8154 20.7148 22.6947 21.8355 21.3076 21.8355H17.2896",
    stroke: "#065EEA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8222 24.3501H16.3055",
    stroke: "#065EEA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0957 13.7927C20.4397 13.5672 19.7291 13.9157 19.5036 14.5717L18.2599 18.1866C18.0344 18.8426 18.3829 19.5532 19.0389 19.7787C19.6949 20.0042 20.4056 19.6557 20.6311 18.9997L21.8747 15.3849C22.1002 14.7289 21.7517 14.0182 21.0957 13.7927Z",
    stroke: "#065EEA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0957 13.7923L21.697 12.0498",
    stroke: "#065EEA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.697 21.8354L22.558 24.3501",
    stroke: "#065EEA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiologyLocationOnMap);
export default __webpack_public_path__ + "static/media/RadiologyLocationOnMap.86bece41229abdb7054cd9d829654dc7.svg";
export { ForwardRef as ReactComponent };